
const DELETED_USER = 'Deleted user';
const NO_NAME = '—';

class Methods {
  static download(id) {
    return `${process.env.REACT_APP_MEDIA_DOWNLOAD_URL}${id}`;
  }

  static capitalizeFirstLetter(string) {
    if (typeof string !== 'string') {
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Whether a person reference on an API row resolved to an existing user.
   * Admin lists keep rows whose user was deleted (`$unwind` with
   * `preserveNullAndEmptyArrays`, `populate` on a dangling id): the reference
   * then arrives as null, without the key, or as `{ fullname: null }`, and
   * never with an `_id`.
   */
  static isPersonPresent(person) {
    return Boolean(person && person._id);
  }

  /** "Firstname Lastname", or a placeholder when the user is gone or has no name. */
  static fullName(person) {
    if (!Methods.isPersonPresent(person)) {
      return DELETED_USER;
    }
    const name = `${Methods.capitalizeFirstLetter(person.firstname)} ${Methods.capitalizeFirstLetter(person.lastname)}`.trim();
    return name || NO_NAME;
  }

  /**
   * The row a list page pushed as `location.state.detail`, or null when the
   * page was opened from a typed URL, a bookmark or a new tab.
   */
  static routeDetail(location) {
    return (location && location.state && location.state.detail) || null;
  }
}

export default Methods;
